module.exports = __webpack_public_path__ + "static/media/pointIcon.5228020a.svg";